export default __webpack_public_path__ + "images/17a06b74f5f11614e5282aa65244cb84.png";